__turbopack_context__.v({
  "switch": "LanguageSwitcher-module__gdGMiG__switch",
});
